export default {
  data() {
    return {
      searchSchema: [
        {
          label: '企业名称',
          itemName: 'name',
          type: 'input',
          allowClear: true,
          placeholder: '请输入企业名称',
        },
        {
          label: '企业ID',
          itemName: 'code',
          type: 'input',
          allowClear: true,
          placeholder: '请输入企业ID',
        },
      ],
      searchData: {
        name: '',
        code: '',
      },
      columns: [
        {
          title: '序号',
          width: 70,
          dataIndex: 'order',
          fixed: 'left',
          align: 'center',
          slots: { title: 'customTitile' },
          customRender: (text, record, index) =>
            (this.pageData.current - 1) * this.pageData.pageSize + (index + 1),
          // scopedSlots: { customRender: 'order'}
        },
        {
          title: '企业名称',
          dataIndex: 'name',
          width: 250,
        },
        {
          title: '企业ID',
          dataIndex: 'code',
          width: 150,
        },
        {
          title: '操作',
          fixed: 'right',
          width: 200,
          dataIndex: 'action',
          slotName: 'action',
          scopedSlots: { customRender: 'action' },
        },
      ],
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
      },
    }
  },
}
